import { createContext } from "react";
import { defaultFilterValues, type FilterValues } from "./filterState.js";

export interface FilterContextValue {
  defaultValues: FilterValues;
  values: FilterValues;
  // The subset of filter values the user has explicitly changed (touched).
  changedValues: Partial<FilterValues>;
  onChange: (newValues: Partial<FilterValues>) => void;
  onReset: () => void;
}

const defaultFilterContextValue: FilterContextValue = Object.freeze({
  defaultValues: defaultFilterValues,
  values: defaultFilterValues,
  changedValues: {},
  onChange: () => {},
  onReset: () => {},
});

export const FilterContext = createContext<FilterContextValue>(
  defaultFilterContextValue,
);
